// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__-VT0L","notes":"styles_notes__hjCaQ"};